import BaseDialog from "@/components/BaseDialog";
import BaseDrawer from "@/components/BaseDrawer";

// 批量录入
export function batchEnterModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('./batchEnterModal'),
    options: {
      width: '600px',
      title: '批量录入产品',
        closeOnPressEscape:false,
        closeOnClickModal:false,
    },
    props,
    cbs
  })
}
/**
 * 素材 自动匹配上传
 * @param {*} param0
 * @returns
 */
export function autoMatchOrder({ props, cbs }) {
  return new BaseDrawer({
    component: ()=>import('./autoMatchOrder'),
    options: {
      size: '1200px',
      title: '自动匹配上传',
      'close-on-press-escape': false,
      wrapperClosable: false,
      'show-close': false,
      'custom-class': 'mi-drawer-create'
    },
    props,
    cbs
  })
}

/**
 * 应用选择
 * @param {*} param0
 * @returns
 */
export function selectSizeModal({ props, cbs, on }) {
  return new BaseDialog({
    component: ()=>import('./selectSizeModal'),
    options: {
      width: '600px',
      title: '存在重复尺寸',
      closeOnPressEscape:false,
      closeOnClickModal:false,
    },
    on,
    props,
    cbs
  })
}

export function tipModal({ props, cbs }) {
  return new BaseDialog({
    component: ()=>import('@/views/marketingManagement/mi/modal/tipModal'),
    options: {
      width: '500px',
      title: '提示',
      'lock-scroll': false
    },
    props,
    cbs,
    on: {}
  })
}
